import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    side_panel_container: {
        maxWidth: '100%',
        "@media print": {
            width: '100%'
        }
    },
    panel_container: {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        "@media print": {
            width: '100%'
        },
        "@media (max-width: 800px)": {
            width: '100vw'
        }
    },
    header_container: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        margin: 0,
        padding: '16px',
        color: theme.palette.common.white,
        backgroundColor: theme.palette.secondary.light,
        boxSizing: 'border-box',
        "@media (min-width: 800px)": {
            minWidth: 500,
        }
    },
    body_container:{
        flexGrow: 1,
        position: 'relative',
    },
    title: {
        fontSize: "23px",
        fontWeight: 600,
        "@media print": {
            display: 'none'
        }
    },
    subtitle: {
        fontSize: '14px',
        color: theme.palette.grey[300],
    },
    closeButton: {
        position: 'absolute',
        right: '20px',
        top: '20px',
        color: theme.palette.common.white,
        cursor: 'pointer',
        borderRadius: '4px',
        display: 'flex',
        "&:hover": {
            backgroundColor: theme.palette.secondary.dark,
        }
    },
    loading: {
        position: 'absolute',
        width: '100%',
        height: '100%'
    }
}));

export {useStyles}